// Port of api/fuel/app/classes/filter/search/games/rules/query/mechanics.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'mechanics',
	isIndex: function() { return 'mechanic' }
})
